import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { inputs, references, whyDiffer } from './data/teaser';
import { PhoneFrame } from './components/PhoneFrame';
import { StrategyOverlay } from './components/StrategyOverlay';
import { PromiseScreen } from './components/screens/PromiseScreen';
import { WhyDifferScreen } from './components/screens/WhyDifferScreen';
import { InputsScreen } from './components/screens/InputsScreen';
import { PhenotypesScreen } from './components/screens/PhenotypesScreen';
import { BridgeScreen } from './components/screens/BridgeScreen';
const EASE = [0.23, 1, 0.32, 1] as const;
const SCREENS = [{
  id: 'promise'
}, {
  id: 'whyDiffer'
}, {
  id: 'inputs'
}, {
  id: 'phenotypes'
}, {
  id: 'bridge'
}] as const;
export function App() {
  const [step, setStep] = useState(0);
  const [strategyOpen, setStrategyOpen] = useState(false);
  const screen = SCREENS[step];
  const next = () => setStep(s => Math.min(s + 1, SCREENS.length - 1));
  const back = () => setStep(s => Math.max(s - 1, 0));
  const restart = () => setStep(0);
  const nav = (() => {
    switch (screen.id) {
      case 'promise':
        return {
          onNext: next,
          nextLabel: 'Explore the evidence',
          footnote: references.intro
        };
      case 'whyDiffer':
        return {
          onBack: back,
          onNext: next,
          nextLabel: whyDiffer.cta,
          footnote: references.midena
        };
      case 'inputs':
        return {
          onBack: back,
          onNext: next,
          nextLabel: inputs.cta,
          footnote: references.munk
        };
      case 'phenotypes':
        return {
          onBack: back,
          onNext: next,
          footnote: references.midena
        };
      case 'bridge':
        return {
          onBack: back
        };
      default:
        return {
          onBack: back,
          onNext: next
        };
    }
  })();
  return <div className="min-h-full w-full bg-mist font-sans" data-id="element-0" data-mp="nv0zhx4tgw79">
      <PhoneFrame step={step} total={SCREENS.length} onOpenStrategy={() => setStrategyOpen(true)} {...nav} data-id="element-1" data-mp="su45bjsmf6ga">
        <AnimatePresence mode="wait" data-id="element-2" data-mp="34nabp7octvk">
          <motion.div key={screen.id} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: EASE
        }} className="flex flex-1 flex-col" data-id="element-3" data-mp="3ud1hdeu8fyd9">
            {screen.id === 'promise' && <PromiseScreen data-id="element-4" data-mp="3gkv01pfcflc8" />}
            {screen.id === 'whyDiffer' && <WhyDifferScreen data-id="element-5" data-mp="3gja7u6gi4ehj" />}
            {screen.id === 'inputs' && <InputsScreen onAdvance={next} data-id="element-6" data-mp="3bncnzq614q00" />}
            {screen.id === 'phenotypes' && <PhenotypesScreen data-id="element-7" data-mp="3qbpp11jz4z1d" />}
            {screen.id === 'bridge' && <BridgeScreen onRestart={restart} data-id="element-8" data-mp="3qdai0mqn49x4" />}
          </motion.div>
        </AnimatePresence>
      </PhoneFrame>

      <AnimatePresence data-id="element-9" data-mp="3limuor7dhlk4">
        {strategyOpen && <StrategyOverlay onClose={() => setStrategyOpen(false)} data-id="element-10" data-mp="2xtv6sc0tfpd5" />}
      </AnimatePresence>
    </div>;
}